<template>
  <v-layout class="mt-5">
    <v-flex md12>
      <v-card class="elevation-7">
        <v-data-table :headers="headers2" :items="items2" hide-actions disable-initial-sort>
          <template slot="headers" slot-scope="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                    'column sortable', 
                    header.value === queryParams.order ? 'active' : '', 
                    'text-xs-'+header.align
                  ]"
              >
                <span>{{ header.text }}</span>
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ props.index + 1}}</td>
            <td class="text-xs-center text-uppercase">{{ props.item.transaction_no }}</td>
            <td class="text-xs-center text-uppercase">{{ props.item.card_no }}</td>
            <td
              class="text-xs-center text-uppercase"
            >{{ $dateFormat(props.item.transaction_date,"HH:mm:ss") }}</td>
            <td class="text-xs-center text-uppercase">{{ props.item.transaction_type.name }}</td>
            <td
              class="text-xs-right text-uppercase"
            >{{ $amountInPeso(props.item.remaining_balance) }}</td>
            <td class="text-xs-right text-uppercase">{{ $amountInPeso(props.item.card_amount) }}</td>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
    props:{
        headers2: {
            type: Array
        },
        items2: {
            type: Array
        },
        queryParams: {
            type: Object
        }
    }
};
</script>

<style scoped>
.table-controls {
  padding: 0 !important;
}
table.v-table td,
th {
  box-shadow: 1px 0px 0px 0px #eee;
}
table.v-table tbody tr {
  cursor: pointer !important;
}
.current-row {
  background-color: #ddd;
}
.row-active {
  box-shadow: 4px -1px 0px 0px rgb(76, 175, 80) inset;
}
.row-inactive {
  color: rgb(244, 67, 54);
  box-shadow: 4px 0px 0px 0px rgb(244, 67, 54) inset;
}
table.v-table td,
th {
  height: 30px !important;
  padding: 0px 5px 0px 5px !important;                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      
}
table.v-table thead tr:not(.v-datatable__progress) {
  height: 30px;
}
table.v-table th {
  padding-left: 5px !important;
  padding-right: 5px !important;                                                                                                                                                                                                                                                                                                                                                                                                                      
} 
.textRight {
  text-align: right;
}
.padding {
  padding: 7px;
}
.vline {
  border-right: 1px solid #eeeeee;
}
.border {
  border: 1px solid #e0e0e0;
}
</style>